import http from "@/api/config"; //axios
function downloadTemp(type,fileName){
    http.get(`/api/File/DownTemplate/${type}`, {
		responseType: 'blob'
	}).then(res=>{
        if (res.status === 200 && res.data) {
            let rtnResult = res.data;
            // console.log(rtnResult);
            let fileUrl = window.URL.createObjectURL(rtnResult);
            let fileLink = document.createElement("a");
            fileLink.href = fileUrl;
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);
            fileLink.click();
          }
    });
}

export default{
    downloadTemp
}
